import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button, Typography } from '@material-ui/core';
import { Formik, Field, Form } from 'formik';
import { TextField } from 'formik-material-ui';
import * as Yup from 'yup';

class ResetPasswordForm extends Component {

  render() {
    return (
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Required')
            .email('Invalid email'),
        })}
        onSubmit={(values, actions) => {
          this.props.onSubmit(values.email, values.password);
          actions.setSubmitting(false);
        }}
      >
        {() => (
          <Form>
            <Field disabled={this.props.isLoggingIn} component={TextField} margin="normal" fullWidth label="Email" variant="outlined" type="email" name="email" />
            <Button disabled={this.props.isLoggingIn} size="large" type="submit" variant="contained" color="primary">Reset password</Button>
            {this.props.authError &&
              <Typography>{this.props.authError.message}</Typography>
            }
          </Form>
        )}
      </Formik>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggingIn: state.authReducer.isLoggingIn,
    authError: state.authReducer.authError,
  };
}

export default connect(mapStateToProps)(ResetPasswordForm);
